import { queryOptions } from '@tanstack/react-query';
import { getOrganization } from 'admin/resources';
import { organizationKeys } from 'admin/queries/queryKeys';
import type { IUserOrganization } from 'types/user';

export const getOrganizationQueryOptions = (organizationId: string) =>
	queryOptions({
		queryKey: organizationKeys.detail(organizationId),
		queryFn: async ({ signal }) => {
			const response = await getOrganization
				.params({ organizationId })
				.send<{ body: IUserOrganization }>(undefined, { signal });
			if (!response.body || response.body.id !== organizationId)
				throw new Error('Organization could not be loaded.');
			return response.body;
		},
		enabled: !!organizationId,
		staleTime: 30_000,
	});
